module.exports = __webpack_public_path__ + "media/images/bbq-d7dbed769728f03100cc153f5dbaafa8.png";